import React from 'react';
import PlainText from 'ati-ui-react/components/PlainText';
import Tooltip from '@components/tooltip';
import classnames from 'classnames';
import { observer } from 'mobx-react-lite';
import * as styles from './Recommendations.scss';
import { toThousandSeparatedNumber, openPassportPopup, getFormattedText } from '../../utils';
import { makePassportRecommendationsUrl } from '../../utils/urlProvider';
import strings from '../../strings';

const Recommendations = ({ row, isMobile }) => {
  const {
    recommendations: {
      asExecutorCount,
      asCustomerCount,
      totalCount,
    },
    firm: {
      atiId,
    },
  } = row;

  const recsCount = totalCount;
  const counter = recsCount ? toThousandSeparatedNumber(recsCount) : '-';

  const hasAsCustomer = asCustomerCount > 0;
  const hasAsExecutor = asExecutorCount > 0;

  const recommendationsUrl = makePassportRecommendationsUrl(atiId);

  if (recsCount > 0) {
    return (
      <div className={styles.recsContainer}>
        <Tooltip
          place="top"
          content={
            <div className={styles.tooltip}>
              {hasAsCustomer &&
                <div className={styles.counterRow}>
                  <span className={styles.text}>{strings.customerRecs}</span><span>{asCustomerCount}</span>
                </div>}
              {hasAsExecutor &&
                <div className={styles.counterRow}>
                  <span className={styles.text}>{strings.executorRecs}</span><span>{asExecutorCount}</span>
                </div>}
            </div>
          }
        >
          <span>
            <a
              href={recommendationsUrl}
              target="_blank"
              className="glz-link"
              onClick={e => openPassportPopup(e, recommendationsUrl)}
              rel="noreferrer"
            >
              <PlainText
                size={isMobile ? 'small' : 'medium'}
                type="success"
                className={classnames(styles.recLink, styles.recommendations)}
              >
                {counter} {isMobile && getFormattedText('recommendationsCounter', recsCount)}
              </PlainText>
            </a>
          </span>
        </Tooltip>
      </div>
    );
  }

  if (isMobile) return null;

  return (
    <div className={styles.recsContainer}>
      <span>
        <PlainText
          size="medium"
          secondary
          className={classnames(styles.recommendations, styles.recommendations__empty)}
        >
          —
        </PlainText>
      </span>
    </div>
  );
};

export default observer(Recommendations);
